
import RapAgentVehicle from "../../pages/rap-agent/rap-manager/vehicle/containers/vehicle";
import RapAgentVehicles from "../../pages/rap-agent/rap-manager/vehicle/containers/vehicles";
import RapAgentJob from "../../pages/rap-agent/smart-booking/job/containers/job";
import RapAgentJobs from "../../pages/rap-agent/smart-booking/job/containers/jobs";
import TransportAgentAddressBook from "../../pages/transport-agent/addressbook";
import AgentTracker from "../../pages/transport-agent/agent-location- track.component";
import TransportAgentHelpCenter from "../../pages/transport-agent/helpcenter";
import TransportAgentHome from "../../pages/transport-agent/home";
import TransportAgentProfile from "../../pages/transport-agent/profile";

import { RoleGuard } from "../guards";



export const TransportAgentAppRoutes = () => {
	 return ([						
			{ path: "home", element: <RoleGuard roles={["Internal"]}><TransportAgentHome /></RoleGuard>},
			{ path: "tracker", element: <RoleGuard roles={["Internal"]}><AgentTracker /></RoleGuard>},
			{ path: "profile", element: <RoleGuard roles={["Internal"]}><TransportAgentProfile /></RoleGuard>},
			{ path: "helpcenter", element: <RoleGuard roles={["Internal"]}><TransportAgentHelpCenter /></RoleGuard>},
			{ path: "address", element: <RoleGuard roles={["Internal"]}><TransportAgentAddressBook /></RoleGuard>},
			{ path: "smart-booking/job", element: <RoleGuard roles={["Internal"]}><RapAgentJobs/></RoleGuard>},
			{ path: "smart-booking/job/:id", element: <RoleGuard roles={["Internal"]}><RapAgentJob /></RoleGuard>},
			{ path: "rap-manager/vehicle", element: <RoleGuard roles={["Internal"]}><RapAgentVehicles /></RoleGuard>},
			{ path: "rap-manager/vehicle/:id", element: <RoleGuard roles={["Internal"]}><RapAgentVehicle /></RoleGuard>},
		])
};
